module.exports = __webpack_public_path__ + "img/walletBox33.9dbcb099.png";